import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { MainNotificationDialogComponent } from './main-notification-dialog.component';

@NgModule({
    declarations: [MainNotificationDialogComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [MainNotificationDialogComponent],
})
export class MainNotificationDialogModule {}
